import { useQueryClient } from "@tanstack/react-query"

import { useAuthMutation } from "@l2r-front/l2r-auth"
import { l2rApiAxiosInstance as axiosInstance } from "@l2r-front/l2r-query"

export function useChangeEmailMutation(config = {}) {
    const queryClient = useQueryClient()

    const url = "me/change_email/"
    return useAuthMutation(
        url,
        axiosInstance.patch,
        {},
        {
            ...config,
            onSuccess: () => {
                queryClient.invalidateQueries({ queryKey: ["user"] })
                queryClient.refetchQueries({ queryKey: ["user"] })
                config.onSuccess && config.onSuccess()
            },
        })
}
